// Filtre yardımcıları — çoklu seçim filtrelerinde "(Boş)" seçeneği desteği.

// Seçenek listesinde boş değerleri temsil eden özel değer. Gerçek id'lerle
// çakışmasın diye string sentinel kullanılıyor (id'ler sayı).
export const BOS_FILTRE = '__bos__';
export const BOS_ETIKET = '(Boş)';

export const bosMu = (v) => v === null || v === undefined || v === '';

// alan: alan adı ya da kayıttan değeri çıkaran fonksiyon
const degerAl = (kayit, alan) => (typeof alan === 'function' ? alan(kayit) : kayit[alan]);

// Veride ilgili alanı boş olan kayıt varsa seçenek listesine "(Boş)" ekler.
// Boş kayıt yoksa liste olduğu gibi döner — seçenek gereksiz yere görünmez.
export const bosSecenekliOptions = (options, data, alan) =>
  (data || []).some(d => bosMu(degerAl(d, alan)))
    ? [...options, { value: BOS_FILTRE, label: BOS_ETIKET }]
    : options;

// Çoklu seçim filtresi: hiç seçim yoksa her kayıt geçer, "(Boş)" seçiliyse
// alanı boş olan kayıtlar eşleşir.
export const secimeUyuyor = (secilenler, deger) => {
  if (!secilenler || secilenler.length === 0) return true;
  if (bosMu(deger)) return secilenler.includes(BOS_FILTRE);
  return secilenler.includes(deger);
};
